import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import brandPath from "@faire/web-api--source/routes/brand/brandToken";
import * as React from "react";
import styled from "styled-components";

import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";

import { FaireX } from "../icons/FaireX";

interface IProps {
  brandName: string;
}

export const FaireAndBrandLogo: React.FC<IProps> = ({ brandName }) => {
  const { isMobile } = useViewport();
  const smallHeader = brandName.length > 30 || isMobile;

  const { faireDirectBrandToken } = useFaireDirectBrand();

  return (
    <Container>
      <Anchor href={faireBaseUrl()}>
        <FaireX />
      </Anchor>
      <Spacer size="1x" />
      <Link to={brandPath(faireDirectBrandToken)}>
        <BrandName
          variant={
            smallHeader ? "subheadingSansRegular" : "pageHeaderSerifRegular"
          }
        >
          {brandName}
        </BrandName>
      </Link>
    </Container>
  );
};

const Container = styled(Row).attrs({ align: "center" })``;

const BrandName = styled(Typography)`
  &&& {
    margin-top: 1px;
  }
`;
